import { DependencyList, EffectCallback, useEffect, useRef } from "react";

export const useSkipMountEffect = (effect: EffectCallback, deps?: DependencyList) => {
  const firstSubmit = useRef(true);
  return useEffect(() => {
    if (firstSubmit.current) {
      firstSubmit.current = false;
      return;
    }
    effect();
  }, deps);
}